
import l1 from "../images/l1.png";
import l2 from "../images/l2.png";
import l3 from "../images/l3.png";
import l4 from "../images/l4.png";
import l5 from "../images/l5.png";
import l6 from "../images/guidance.png";
import l7 from "../images/hero.png";
import l8 from "../images/connect-hero.png";
import l9 from "../images/eventDetail2.png";

function getPostDetails() {

    var postDetails = [
        {
            "title":"Shorten LinkedIn Profile URLs",
            "description": [ "Shorten your profile URLs to make it more personalized, and look better", 
                             "Shorter URLs look catchy when you share them, and they are immediately noticeable.", 
                             "Here’s how you can shorten your LinkedIn profile URLs"],
            "detailImg": l1
          },
          {
            "title":"Add A Photo and A Cover Image",
            "description": ["Having a photo is an absolute necessity", 
                            "Have a clear headshot, without a distracting background", 
                            "Avoid selfies, ethnic day photos, group photos, informal pictures with sunglasses/hoodies etc.",
                            "Add a cover image related to your job, or what you’re currently studying. Cover images grab eyeballs right when your profile is opened, so upload the best image you get!"],
            "detailImg": l9
          },
          {
            "title":"LinkedIn Profile Headline and Summary",
            "description": ["Your profile headline must be a concise description of your past experiences and your accomplishments", 
                            "Summarize what you do, what your strengths are and what your career aspirations are in your summary. Use a simple language, avoid jargon", ],
            "detailImg": l2
          },
          {
            "title":"Job Experience",
            "description": ["Starting with your current position, write about projects, accomplishments, and the value you bring to your team and organization. Keep it clear and concise", 
                            "Put in as many details as possible - Tag your companies, your duration of work, skills etc.", 
                            "Highlight key points and achievements, show numbers and stats if you have them",
                            "Use points to describe your achievements, instead of paragraphs"],
            "detailImg": l3
          },
          {
            "title":"Education",
            "description": ["Tag your colleges", 
                            "Add your accomplishments - clubs, college fest responsibilities, projects, research papers etc.", 
                            "Adding your college details makes it easier for you to network with your college alumni, ask for job referrals, and provide recruiters with data that leverages the power of our alumni network. Get 11X the profile views."],          
            "detailImg": l4
          },
          {
            "title":"Skills and Endorsements",
            "description": ["Add skills you want to be known for", 
                            "Get endorsements from your colleagues", 
                            "Add skills directly related to your job role, your strengths and skills relevant to your career path",
                            "Avoid generic skills like Microsoft Word, Hard working, Swimming etc."],          
            "detailImg": l8
          },
          {
            "title":"Recommendations",
            "description": ["Get recommendations from your colleagues or your boss. Make sure you have a positive mindset when asking for a recommendation from your boss or your colleagues.", 
                            "Students can get recommendations from their professors, or friends. Ensure your recommendations are professional!", ],          
            "detailImg": l6
          },
          {
            "title":"LinkedIn for Higher Education",
            "description": ["For many of us, getting a post-grad degree from a reputed university is an important step in our career path. Preparations begin soon after graduation in some cases, and sometimes it starts as early as the second year of engineering. ", 
                            "Gathering information about your future post-grad programs, research domains, visa procedures, career paths and the like are extremely important to deciding which universities to apply to, and eventually, this information lays a foundation on which you define your career and your future. "],          
            "detailImg": l7
          },
          {
            "title":"Leveraging LinkedIn - Applying for Grad School",
            "description": ["Universities abroad look for all-round performance, so note down your achievements, co-curricular and extra-curricular activities, projects on your profile ", 
                            "Use this as an opportunity to describe your personality, elucidate your motivations, your aspirations and what you can bring to the university you apply to.", 
                            "Apart from your transcripts and your SOP, your LinkedIn profile is an avenue for your admissions officers and professors to know you better"],          
            "detailImg": l5
          }
    ]

    return postDetails;
}

export default getPostDetails;